import classNames from 'classnames';
import Image from 'next/image';
import { useContext } from 'react';

import Link from '~/shared/components/link';
import ReadMoreLink from '~/shared/components/slider/components/read-more-link';
import { RootContext } from '~/shared/configs/root-context';
import { PAGE_NAMES } from '~/shared/constants';
import { getLocaleLink } from '~/shared/helpers/browser-helpers';
import { getUrl } from '~/shared/helpers/string-helpers';
import { useTypedTranslation } from '~/shared/hooks';
import type { PostType } from '~/shared/types/post-type';

import './infinite-slide.scss';

import noImage from '~/assets/no-image.webp';

type SingleItemComponentPropsType = {
  pageToGo: string;
  data: PostType;
};

const InfiniteSlide = ({ pageToGo, index, getTagLink, activeSlideIndex, data }: SingleItemComponentPropsType) => {
  const rootContext = useContext(RootContext);
  const t = useTypedTranslation(['link']);
  const isActiveSlide = activeSlideIndex === index || (activeSlideIndex === -1 && index === 5);

  return (
    <div
      className={classNames('infinite-slide', `infinite-slide-${index}`, {
        'slide--slick-slide-active': isActiveSlide,
      })}
    >
      <div className="infinite-slide__overlay">
        <div className="infinite-slide__container-wrapper">
          <div className="infinite-slide__content">
            <div className="infinite-slide__main-content">
              <div className="infinite-slide__tags">
                {data?.tags?.map((tag, i) => {
                  return (
                    <Link className="infinite-slide__tag" key={i} href={getTagLink(tag)}>
                      {tag?.name}
                    </Link>
                  );
                })}
              </div>
              <Link
                href={getLocaleLink(getUrl({ link: PAGE_NAMES.POST, alias: data?.alias }), rootContext?.lng)}
                className="infinite-slide__title"
              >
                {data?.title}
              </Link>
            </div>
            {isActiveSlide && (
              <ReadMoreLink
                href={getLocaleLink(getUrl({ link: PAGE_NAMES.POST, alias: data?.alias }), rootContext?.lng)}
                content={t('link.read-more')}
              />
            )}
          </div>
        </div>
        <div className="infinite-slide__image-container">
          <div className="infinite-slide__image-wrapper">
            <Image
              loading="lazy"
              priority={false}
              fill
              src={data?.thumbnail?.path ?? noImage.src}
              alt={data?.title}
              title={data?.title}
              style={{
                objectFit: 'cover',
              }}
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 25vw"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfiniteSlide;
